export default __webpack_public_path__ + "static/media/cricket.941974a6.png";